import React, { useMemo } from "react";
import { useGetBiActivityTrendsQuery } from "../../app/api/console/consoleBiApiSlice";
import ActivityTrendsChart from "./ActivityTrendsChart";

function useDefaultBiWindow() {
  return useMemo(() => {
    const end = new Date();
    const start = new Date(Date.now() - 5 * 30 * 24 * 60 * 60 * 1000);
    return {
      startDate: start.toISOString().split("T")[0],
      endDate: end.toISOString().split("T")[0],
    };
  }, []);
}

/**
 * BI activity trends (DAU / WAU; MAU hidden vs main BI dashboard) for one brand.
 * Fetches only when `enabled` (e.g. row expanded).
 */
export default function CustomerBrandActivityTrends({ brandName, enabled, height = 320, startDate: startProp, endDate: endProp }) {
  const fallback = useDefaultBiWindow();
  const startDate = startProp ?? fallback.startDate;
  const endDate = endProp ?? fallback.endDate;

  const { data, isLoading, error } = useGetBiActivityTrendsQuery(
    {
      days: 90,
      startDate,
      endDate,
      brands: brandName ? [brandName] : [],
      useProd: true,
    },
    { skip: !enabled || !brandName }
  );

  return (
    <ActivityTrendsChart
      data={data}
      isLoading={isLoading}
      error={error}
      height={height}
      hideMonthlyMau
    />
  );
}
